<script setup>
import {getCurrentInstance, onMounted, reactive, ref} from "vue";
import {useRouter} from "vue-router";
import {accessControlApi, articleListsApi} from "@/api/forwriting_index";
import CheckPointLimit from "@/views/forwriting/fw00_check_point_limit.vue"
import LoadingIcon from "@/components/LoadingIcon.vue";

const router = useRouter();
const isLoading = ref(false);
const instance = getCurrentInstance()

const item = reactive({
  article_list_name: ""
})

const handleReturn = () => {
  // router.back();
  router.push(`/forwriting/article_lists`)
};

function isEmpty( val)
{
  return (
      val == null || (
          typeof val === "string" &&
          val.trim().length === 0
      )
  )
}

const check_modal_msg = ref( "")

function has_empty_fields()
{
  let t = instance.proxy.$t
  let f_list = ""

  if( isEmpty( item.article_list_name))
    f_list += t('ArticleLists_New.list_name') + ", "

  // has some empty fields...
  if( f_list.length > 0) {
    check_modal_msg.value = f_list.substring( 0, f_list.length-2)
        + t( 'sales_templates_new.check_modal_msg')
    return true
  }

  return false
}

// 開啟對話框
const openCheckModal = () =>
{
  let has_empty = has_empty_fields()
  // console.log( "* has_empty", has_empty)

  if( has_empty)
  {
    // console.log( "** has_empty", has_empty)

    // 顯示警告對話框
    let btn = document.getElementById("showCheckModal");
    btn.click();
  }
  return has_empty
};

const handle_create = async () => {
  if (openCheckModal()) {
    return
  }

  isLoading.value = true

  const _dict = {
    "article_list_name": item.article_list_name,
  }
  console.log( "_dict:", _dict)

  const resp_create = await articleListsApi.create( _dict)
  console.log( "resp_create:", resp_create)

  if( resp_create.status !== 200) {
    throw new Error("create new article_list ERROR");
  }
  isLoading.value = false

  await router.push(`/forwriting/article_lists`)
}

onMounted(async () => {
  if (!await accessControlApi.check_option_access()) {
    await router.push(`/forwriting/options_error`)
  }

  // check the point_limit
  point_limit.is_over = await ref_CheckPointLimit.value.check()
  console.log( "is_over:", point_limit.is_over)
})

// ==== modal_over_points ====
const ref_CheckPointLimit = ref(null)
const point_limit = reactive({
  is_over: false,
})

</script>

<template>
  <LoadingIcon :is-loading="isLoading"></LoadingIcon>

  <!-- modal_over_points -->
  <CheckPointLimit ref="ref_CheckPointLimit"></CheckPointLimit>

  <!-- Check modal begin -->
  <button id="showCheckModal" data-bs-toggle="modal" data-bs-target="#CheckModal" style="display:none;"></button>
  <div class="modal fade" id="CheckModal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">
            {{ $t('ArticleLists_New.check_modal_title') }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p>{{check_modal_msg}}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" data-bs-dismiss="modal">
            {{ $t('ArticleLists_New.check_modal_close') }}</button>
        </div>
      </div>
    </div>
  </div>
  <!-- Check modal end -->

  <div class="container">

    <div>
      <h3>{{ $t('ArticleLists_New.h3')}}</h3>
    </div>

    <div class="row">

      <!--  article_list_name-->
      <label for="article_list_name" class="form-label required">
        {{ $t('ArticleLists_New.list_name')}}</label>

      <div class="input-group mb-3">
        <input type="text" class="form-control" id="article_list_name"
                   v-model="item.article_list_name">
      </div>
    </div>

    <div class="row" style="height: 320px;">
    </div>

    <div class="row">
      <div class="d-grid gap-2 d-md-flex justify-content-md-end">

        <button class="btn btn-primary" type="button" @click="handle_create">
          {{ $t('ArticleLists_New.create')}}</button>

        <button class="btn btn-primary" type="button" @click="handleReturn">
          {{ $t('ArticleLists_New.return')}}</button>

      </div>
    </div>

  </div>

</template>

<style scoped>

</style>